import type { BetLoopKambiShareCoupon, BetLoopShareTicket } from '@core/Areas/BetLoop/types'

export const isKambiSharedCoupon = (
  ticket: BetLoopShareTicket | BetLoopKambiShareCoupon
): ticket is BetLoopKambiShareCoupon => {
  if ('legs' in ticket) return false

  return 'bets' in ticket && 'outcomes' in ticket
}
